export const DEFAULT_BUSINESS_CASE_PAYMENT_UNPAID_MINIMUM_DAYS = 3;
